import { Button, Grid } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { enviarItemExtraAction, obtenerExtrasContratadosAction } from "./../../../ducks/ExtrasContratadosDuck"
import { useState } from "react"
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import { formatDinero } from "./../../../utils/formatDinero"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { makeStyles } from "@material-ui/core"
import {offLoadAction, onLoadAnction} from "./../../../ducks/loadDuck"
export const FAutorizarStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const ModalMensaje = (props) => {
    const { Compra, Moneda, open = false, setOpen = () => { } } = props
    console.log("🚀 ~ ModalMensaje ~ Compra:", Compra)
    const dispatch = useDispatch()
    const classes = FAutorizarStyle()
    const handleClose = () => {
        setOpen(false)
    }
    const onGuardar = () => {
        DialogMessage.fire({
            title: `¿Esta seguro de mandar al area de finanazas
            la solicitud de pago de este Item?`,
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: ""}))
                dispatch(enviarItemExtraAction({ idCompra: Compra.idCompra })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status || Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Operación exitoasa",
                    })
                    dispatch(obtenerExtrasContratadosAction())
                })
            }
        })
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Solicitar Pago de Item"
            />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <div style={{ margin: '10px' }}>
                        <p>Motivo: <b>Extra</b></p>
                        <p>Monto pagado: <b>{formatDinero(Compra?.MontoProveedor)} {Moneda?.Clave}</b></p>
                    </div>
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={onGuardar}
                    >
                        Aplicar
                    </Button>
                </Grid>
            </Grid>
        </ModalBase>
    )
}

const FEnviarExtra = (props) => {
    const { Compra, disabled = false, Moneda } = props
    const [open, setOpen] = useState(false)
    const onOpen = () => {
        setOpen(true)
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onOpen} disabled={disabled}>
                Enviar finanzas
            </Button>
            <ModalMensaje open={open} Moneda={Moneda} setOpen={setOpen} Compra={Compra} />
        </div>
    )
}
export default FEnviarExtra